import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';

import {
  isMobileSelector,
  isPreviewSelector,
  isSdkSelector
} from 'redux/selectors/global';
import { IHeaderProps } from 'components/layout/Header';
import {
  Wrapper,
  Header,
  Content,
  PageContent,
  FooterComponent
} from 'components/layout/styles';
import ErrorAlert from 'components/widgets/ErrorAlert/ErrorAlert';

export interface ILayoutProps {
  className?: string;
  headerProps?: IHeaderProps;
  children: ReactNode;
  withPci?: boolean;
  renderHeader?: boolean;
}

const Layout = ({
  className,
  headerProps,
  children,
  withPci,
  renderHeader = true
}: ILayoutProps) => {
  const isSdk = useSelector(isSdkSelector);
  const isMobile = useSelector(isMobileSelector);
  const isPreview = useSelector(isPreviewSelector);

  const shouldRenderHeader = Boolean(!isSdk && renderHeader);
  const renderFooter = Boolean(!isSdk);

  return (
    <Wrapper isPreview={isPreview} className={className}>
      {shouldRenderHeader && (
        <Header isPreview={isPreview} enableErrorAlert={!isMobile} {...headerProps} />
      )}
      {isMobile && <StyledErrorAlert className={className} />}
      <Content data-testid="layout-content">
        <PageContent>{children}</PageContent>
        {renderFooter && <FooterComponent withPci={withPci} />}
      </Content>
    </Wrapper>
  );
};

export default Layout;

const StyledErrorAlert = styled(ErrorAlert)`
  margin-top: 7rem;
  ${({ theme }) =>
    theme.view.isMobile &&
    css`
      width: 100%;
    `}
`;
